export default ({
  status,
  message,
  groupMessage,
  columnMessage,
  isGroupNotificationDisplayedOnRoot = true,
  isGroupNotificationDisplayedNextToName = false,
  isForecastOverTarget = false,
}) => ({
  status,
  message,
  groupMessage,
  columnMessage,
  isGroupNotificationDisplayedOnRoot,
  isGroupNotificationDisplayedNextToName,
  ...(isForecastOverTarget ? { isForecastOverTarget: true } : {}),
});
